export default __webpack_public_path__ + "static/media/search_icon.f5fa0f94.svg";